module.exports = __webpack_public_path__ + "img/226.7e0a27a8.png";